import { useState } from 'react';
import { Clock, ArrowRight, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

interface TrialBannerProps {
    daysLeft: number;
    isTrialing: boolean;
}

export function TrialBanner({ daysLeft, isTrialing }: TrialBannerProps) {
    const [dismissed, setDismissed] = useState(false);
    const navigate = useNavigate();

    if (!isTrialing || dismissed) return null;

    const isUrgent = daysLeft <= 3;
    const bgClass = isUrgent
        ? 'bg-destructive text-destructive-foreground'
        : 'bg-primary text-primary-foreground';

    return (
        <div className={`${bgClass} px-4 py-2 flex items-center justify-between text-sm`}>
            <div className="flex items-center gap-2">
                <Clock className="h-4 w-4" />
                <span>
                    {daysLeft === 0
                        ? 'Your free trial ends today!'
                        : `${daysLeft} day${daysLeft !== 1 ? 's' : ''} left in your free trial`}
                </span>
            </div>
            <div className="flex items-center gap-2">
                <Button
                    size="sm"
                    variant={isUrgent ? 'secondary' : 'secondary'}
                    onClick={() => navigate('/settings/billing')}
                    className="h-7 text-xs"
                >
                    Upgrade now
                    <ArrowRight className="h-3 w-3 ml-1" />
                </Button>
                <button onClick={() => setDismissed(true)} className="opacity-70 hover:opacity-100">
                    <X className="h-4 w-4" />
                </button>
            </div>
        </div>
    );
}